import styled, { css } from 'styled-components';
import { Tooltip as TooltipWrapperComponent } from '@prisjakt/ui/tooltip';
import { StyledTooltip as TooltipComponent } from 'src/components/tooltip-new/styles';
import { layout, media } from '@prisjakt/ui-base';
import { ToggleButton, ButtonIcon } from '@prisjakt/ui/button/variants';

export const VariantGroupWrapper = styled.div`
  max-width: calc(
    100vw - ${layout.measurements.spacing050} -
      ${layout.measurements.spacing050}
  );

  ${media.mediumDown`
    max-width: 100vw;
    margin: 0 -0.4rem;
    overflow-x: auto;
  `};
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${layout.measurements.spacing050};
  row-gap: ${layout.measurements.spacing025};

  ${media.mediumDown`
    margin: 0;
    padding: 0;
    padding: 2px 0;
    flex-wrap: nowrap;

    > :first-child {
      margin-left: ${layout.measurements.spacing050};
    }

    &::after {
      content: '\\00a0';
      display: block;
      width: ${layout.measurements.spacing100};
      height: 1px;
      order: 99;
    }
  `}
`;

type TooltipProps = {
  order: number;
};

export const Tooltip = styled(TooltipWrapperComponent)<TooltipProps>(
  props => css`
    flex: 0 0 auto;
    order: ${props.order};

    ${TooltipComponent} {
      ${media.mediumDown`
        display:none;
      `};
    }
  `
);

type SelectableButtonProps = {
  $order: number;
};

export const SelectableButton = styled(ToggleButton)<SelectableButtonProps>(
  props => css`
    display: flex;
    min-width: 40px;
    min-height: 40px;

    ${props.$order &&
      css`
        order: ${props.$order};
      `}
  `
);

export const ShowMoreLessButton = styled(ToggleButton)<SelectableButtonProps>(
  props => css`
    display: flex;
    min-width: 40px;
    min-height: 40px;
    justify-content: center;
    padding: 0;

    ${props.$order &&
      css`
        order: ${props.$order};
      `}
  `
);

type ColorProps = {
  $variantData: string;
};

export const Color = styled(ButtonIcon)<ColorProps>(
  props => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    min-width: 16px;
    height: 16px;
    min-height: 16px;
    border-radius: 16px;
    background: ${props.$variantData};

    svg {
      width: 12px;
      height: 12px;
      color: ${props.theme.colors.base0};
    }

    ${props.$variantData === '#FFFFFF' && // Custom styling for color white
      css`
        border: 1px solid ${props.theme.colors.base300};

        svg {
          color: ${props.theme.colors.base900};
        }
      `}
  `
);

export const ShowMoreLessInner = styled.div`
  color: ${p => p.theme.colors.maybeBlue700};
  line-height: 1;
`;

type WrapLineProps = {
  order: number;
};

export const WrapLine = styled.div<WrapLineProps>(
  props => css`
    flex: 1 0 100%;
    order: ${props.order};
  `
);
